import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

const LANGUAGE_STORAGE_KEY = 'ui-language';
const DEFAULT_LANGUAGE = 'ar';

@Injectable({ providedIn: 'root' })
export class AppSettings {
  public settings = new Settings(
    'ElMal3ab', // theme name
    true, // loadingSpinner
    true, // fixedHeader
    true, // fixedSidenav
    false, // fixedSidenavUserContent
    false, // fixedFooter
    true, // sidenavIsOpened
    true, // sidenavIsPinned
    'vertical', // horizontal , vertical
    'default', // default, compact, mini
    'blue-dark', // indigo-light, teal-light, red-light, gray-light, blue-dark, green-dark, pink-dark, gray-dark
    true, // true = rtl, false = ltr,
    DEFAULT_LANGUAGE // ar,en  default language
  );

  constructor() {
    this.applyLanguage(this.readStoredLanguage());
  }

  setLanguage(language: string): void {
    const lang = language === 'en' ? 'en' : 'ar';
    this.applyLanguage(lang);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  }

  private readStoredLanguage(): string {
    const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return saved === 'en' || saved === 'ar' ? saved : DEFAULT_LANGUAGE;
  }

  private applyLanguage(language: string): void {
    this.settings.language = language;
    this.settings.rtl = language === 'ar';
  }
}
